<script setup lang="ts">
const $props = defineProps<{
	text: string
	registrationLine: App.Data.Registration.RegistrationLineData
}>()

const { closeLocally } = useDialog()

const form = useForm({
	method: 'PUT',
	url: route('registrationLines.updatePlateNumber', { registrationLine: $props.registrationLine.uuid }),
	reset: false,
	fields: {
		plate_number: $props.registrationLine.plate_number || '',
	},
	hooks: {
		success: () => {
			closeLocally()
		},
	},
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<modal-base :title="t('app.rider_plate_number', { rider: registrationLine.full_name })">
		<div v-if="text" class="mb-6" v-html="text" />
		<form class="space-y-5" @submit.prevent="form.submit">
			<form-input-wrapper :label="t('app.plate_number')" for="plate_number" :errors="form.errors.plate_number">
				<form-input-text
					id="plate_number"
					v-model="form.fields.plate_number"
					:disabled="form.processing"
					maxlength="6"
				/>
			</form-input-wrapper>

			<div class="flex justify-end space-x-4">
				<button-base variant="secondary" type="button" @click="closeLocally">
					{{ t('app.cancel') }}
				</button-base>

				<button-base type="submit" :loading="form.processing">
					{{ t('app.save') }}
				</button-base>
			</div>
		</form>
	</modal-base>
</template>
